"use client";

import { JSX, ReactNode, useCallback } from "react";
import { cn } from "~/lib/utils";
import Carousel from "~/componentsDS/Carousel";
import { CarouselApi, CarouselContentVisible, CarouselItem } from "~/components/ui/carousel";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import { useTrackEvent } from "~/hooks/useTrackEvent";
import HowItWorksStepCard from "../../components/HowItWorksStepCard";
import { hiwData } from "../../data/hiw-data";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";

export type StepItem = {
    imageUrl: string;
    icon: JSX.Element;
    title: string;
    description: ReactNode;
}

type Props = {
    steps?: StepItem[];
    classNameCarousel?: string,
}   

const HowItWorksSteps = ({
    steps = hiwData,
    classNameCarousel,
}: Props) => {

    const sendEvent = useTrackEvent();

    const onSelect = useCallback((emblaApi: CarouselApi) => {
        if (!emblaApi) return;

        const idx = emblaApi.selectedScrollSnap();
        const item = steps[idx];

        if (!item) return;

        sendEvent({
            event: "user_interaction",
            value: {
                event_name: GTM_EVENT_NAMES.LP_INTERACTION,
                widget: "lp_steps",
                meta_data: {
                    image_title: item.title,
                    image_count: idx + 1,
                },
            },
        });
    }, [sendEvent, steps]);

    return (
        <ElementorContainer>
            <div className={cn("w-[100vw] overflow-hidden mb-8 max-md:-mx-6 max-md:px-6 max-[390px]:pt-4 md:mb-6 md:w-full", classNameCarousel)}>
                <Carousel
                    onSelect={onSelect}
                    loop={false}
                    variant="compact"
                    compactPaginationAlign="right"
                    compactPaginationBg="bg-trueBlack/10 backdrop-blur-[25px]"
                    compactPaginationDotColor="bg-gray300"
                    opts={{
                        align: "center",
                        skipSnaps: false,
                        dragFree: false,
                    }}
                    className="w-full"
                >
                    <CarouselContentVisible className="max-md:ml-[-6px] md:ml-[-15px]">
                        {steps.map((step, index) => (
                            <CarouselItem
                                key={index}
                                className="flex-shrink-0 basis-full pl-[6px] md:basis-1/2 md:pl-[15px] xl:basis-1/3"
                            >
                                <HowItWorksStepCard
                                    stepNumber={index + 1}
                                    {...step}
                                />
                            </CarouselItem>
                        ))}
                    </CarouselContentVisible>
                </Carousel>
            </div>
        </ElementorContainer>
    );
};

export default HowItWorksSteps;